import React from 'react';
import {useTheme} from '@material-ui/core/styles';

export const RegularSpacer = ({size = 1}) => {
  const theme = useTheme();
  const marginValue = theme.spacing(size);
  const spacerStyle = {margin: marginValue};
  return <div style={spacerStyle}></div>;
};
